// extracted by mini-css-extract-plugin
module.exports = {"card":"_1410bfd27b--card--zTdYv","logo":"_1410bfd27b--logo--CFr9q","name":"_1410bfd27b--name--myApa","active-date":"_1410bfd27b--active-date--FP26h"};